import styled from "styled-components";
import { LayoutConst } from "core/modules/layout.module";
import { CustomHollowButton, RectangularButtonHollow } from "../buttons";

interface ButtonProps {
  theme: {
    name: string;
    projectEdit?: {
      btns?: {
        navbar?: {
          disabled?: {
            color?: string;
            bg?: string;
          };
        };
      };
    };
  };
  isDeziiign?: boolean;
  isGeograffee?: boolean;
  isCGRAVE?: boolean;
  isGeoActive?: boolean;
  isHSEDesign?: boolean;
  isContinuumSite?: boolean;
  isCreativeHSE?: boolean;
  isLMSHSECreative?: boolean;
  isGameDeziiign?: boolean;
  isSuperPuper?: boolean; // Добавлено, если используется
}

export const CustomButton = styled(CustomHollowButton)`
  border: 1px solid ${({ theme }) => theme.projectEdit.btns.navbar.exit.border.notActive.color};
  height: 38px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto;
  width: auto;
  padding-left: 24px;
  padding-right: 24px;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }


  // @media(max-width: ${LayoutConst.screen.m_1024}px) {
  //   height: 32px !important;
  // }
`;

export const ButtonEdit = styled(RectangularButtonHollow).attrs<ButtonProps>((props) => ({
  isDeziiign: props.isDeziiign,
  isGeograffee: props.isGeograffee,
  isCGRAVE: props.isCGRAVE,
  isCreativeHSE: props.isCreativeHSE,
  isLMSHSECreative: props.isLMSHSECreative,
  isGameDeziiign: props.isGameDeziiign,
  isContinuumSite: props.isContinuumSite,
  isSuperPuper: props.isSuperPuper,
}))<ButtonProps>`
  height: 38px !important;
  min-height: 32px;
  font-weight: 600 !important;
  padding-left: 24px;
  padding-right: 24px;
  min-width: auto !important;
  width: auto !important;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }

  /* Стили для активного состояния (когда кнопка не disabled) */
    &:not(:disabled) {
    background-color: ${(props) => {
      if (props.theme.name === "black" || props.isGameDeziiign) return "#FFFFFF"; 
      if (props.isDeziiign) return "black";
      if (props.isGeograffee || props.isCreativeHSE || props.isLMSHSECreative) return "#A4B54D";
      return "white";   
    }} !important;

    color: ${(props) => {
      if (props.theme.name === "black") return "#000000"; 
      
      if (props.isCGRAVE || props.isGameDeziiign || props.isContinuumSite || props.isSuperPuper) return "#000";
      
      if (props.isDeziiign) return "white";
      
      return "#000"; 
    }} !important;
  }

  /* Стили для состояния disabled */
  &:disabled {
    background-color: ${({ theme }) =>
      theme.projectEdit?.btns?.navbar?.disabled?.bg || "#ccc"} !important;
    color: ${({ theme }) =>
      theme.projectEdit?.btns?.navbar?.disabled?.color || "#fff"} !important;
  }
`;import styled from "styled-components";
import { LayoutConst } from "core/modules/layout.module";
import { CustomHollowButton, RectangularButtonHollow } from "../buttons";

interface ButtonProps {
  theme: {
    name: string;
    projectEdit?: {
      btns?: {
        navbar?: {
          disabled?: {
            color?: string;
            bg?: string;
          };
        };
      };
    };
  };
  isDeziiign?: boolean;
  isGeograffee?: boolean;
  isCGRAVE?: boolean;
  isGeoActive?: boolean;
  isHSEDesign?: boolean;
  isContinuumSite?: boolean;
  isCreativeHSE?: boolean;
  isLMSHSECreative?: boolean;
  isGameDeziiign?: boolean;
  isSuperPuper?: boolean; // Добавлено, если используется
}

export const CustomButton = styled(CustomHollowButton)`
  border: 1px solid ${({ theme }) => theme.projectEdit.btns.navbar.exit.border.notActive.color};
  height: 38px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto;
  width: auto;
  padding-left: 24px;
  padding-right: 24px;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }


  // @media(max-width: ${LayoutConst.screen.m_1024}px) {
  //   height: 32px !important;
  // }
`;

export const ButtonEdit = styled(RectangularButtonHollow).attrs<ButtonProps>((props) => ({
  isDeziiign: props.isDeziiign,
  isGeograffee: props.isGeograffee,
  isCGRAVE: props.isCGRAVE,
  isCreativeHSE: props.isCreativeHSE,
  isLMSHSECreative: props.isLMSHSECreative,
  isGameDeziiign: props.isGameDeziiign,
  isContinuumSite: props.isContinuumSite,
  isSuperPuper: props.isSuperPuper,
}))<ButtonProps>`
  height: 38px !important;
  min-height: 32px;
  font-weight: 600 !important;
  padding-left: 24px;
  padding-right: 24px;
  min-width: auto !important;
  width: auto !important;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }

  /* Стили для активного состояния (когда кнопка не disabled) */
    &:not(:disabled) {
    background-color: ${(props) => {
      if (props.theme.name === "black" || props.isGameDeziiign) return "#FFFFFF"; 
      if (props.isDeziiign) return "black";
      if (props.isGeograffee || props.isCreativeHSE || props.isLMSHSECreative) return "#A4B54D";
      return "white";   
    }} !important;

    color: ${(props) => {
      if (props.theme.name === "black") return "#000000"; 
      
      if (props.isCGRAVE || props.isGameDeziiign || props.isContinuumSite || props.isSuperPuper) return "#000";
      
      if (props.isDeziiign) return "white";
      
      return "#000"; 
    }} !important;
  }

  /* Стили для состояния disabled */
  &:disabled {
    background-color: ${({ theme }) =>
      theme.projectEdit?.btns?.navbar?.disabled?.bg || "#ccc"} !important;
    color: ${({ theme }) =>
      theme.projectEdit?.btns?.navbar?.disabled?.color || "#fff"} !important;
  }
`;